import {
  GetUrlParams,
  PAGINATION_PARAMS,
  PER_PAGE_KEY_DEFAULT,
  PER_PAGE_KEY_SITES,
} from '@lib/enums/urls';

export const getPageCount = (totalEntries?: number, perPage?: number) => {
  if (!totalEntries || !perPage) return 0;
  return Math.ceil(totalEntries / perPage) || 0;
};

// Guards against a non-integer/garbage page or per-page value (e.g. a stale
// or hand-edited `?page=1.5` / `?perPage=abc` URL) reaching a GraphQL `Int`
// variable, or `page`'s case reaching react-paginate's `forcePage`, where it
// never settles and causes an infinite re-render loop.
export const sanitizeIntParam = (value: unknown, fallback: number): number => {
  const parsed = Math.trunc(Number(value));
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const sanitizePageParam = (value: unknown): number =>
  sanitizeIntParam(value, 1);

export const sanitizePerPageParam = (value: unknown): number =>
  sanitizeIntParam(value, Number(PER_PAGE_KEY_DEFAULT));

export const getPaginationParamsByPathname = (pathname: string) => {
  if (pathname.includes('sites')) {
    return {
      ...PAGINATION_PARAMS,
      [GetUrlParams.PerPage]: PER_PAGE_KEY_SITES,
    };
  }
  return PAGINATION_PARAMS;
};
